import React, {useEffect} from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { FiSettings } from 'react-icons/fi';
import { TooltipComponent } from '@syncfusion/ej2-react-popups';

import { Navbar, Footer, Sidebar, ThemeSettings } from '../components';
import { Mandantes, AsignaManDocMaq, DocumentosGenerales, ReporteDocumentos, Autorizar, Clientes,Capacidades,
  Usuarios,Maquinas,Equipos, IngresoObra, SalidaObra ,Parametros, Solicitudes,ConsultaMaquinas,CentroCosto,
  AsignaMaquina, Carpetas ,BitacoraSolicitud, BitacoraEquipo, EquipmentReviewInboxFull, Tickets,
  UserInbox, AuditoriaLog, Cargos, Personas, OlvidePassword, RecuperarPassword, EstatusEquipos,
  Acreditacion, GestionCarpetas, FichaEquipo, TraspasoCC} from '../pages';
import	DashboardN from '../pages/Dashboard/DashboardN';	
import Login from '../pages/Login';

import  {fetchUser}  from '../utils/fetchUser';

import '../App.css';
import { useStateContext } from '../contexts/ContextProvider';

const Home = () => {
    const {currentMode, setCurrentColor, setCurrentMode, activeMenu, currentColor, themeSettings, setThemeSettings } = useStateContext();
    const navigate = useNavigate();
    const User = fetchUser();
    useEffect(() => {
      const User = fetchUser();
  
      if (!User) navigate('/login');
    }, []);
  

    useEffect(() => {
        const currentThemeColor = localStorage.getItem('colorMode');
        const currentThemeMode = localStorage.getItem('themeMode');
        if (currentThemeColor && currentThemeMode) {
        setCurrentColor(currentThemeColor);
        setCurrentMode(currentThemeMode);
        }
    }, []);
  
    return (
      <div className={currentMode === 'Dark' ? 'dark' : ''}>
        <div className="flex relative dark:bg-main-dark-bg">

        {activeMenu ? (
          <div className="w-72 fixed sidebar dark:bg-secondary-dark-bg bg:#F5F9FA  "> 
            <Sidebar />
          </div>
        ) : (
          <div className="w-0 dark:bg-secondary-dark-bg">
            <Sidebar />
          </div>
        )}
            <div
              className={
                activeMenu
                  ? 'dark:bg-main-dark-bg  bg-main-bg min-h-screen md:ml-72 w-full  '
                  : 'bg-main-bg dark:bg-main-dark-bg  w-full min-h-screen flex-2 '
              }
            >
            <div className="fixed md:static bg-blue-900 dark:bg-main-dark-bg navbar w-full h-16">
              <Navbar />
            </div>
          <div>
  
          {/*themeSettings && (<ThemeSettings />)*/}
  
              <Routes>
                {/* dashboard  */}
                <Route path="/login" element={(<Login />)} />

                <Route path="/*" element={(
                  
                    User && (User.rol === 'Expeditor'  || User.rol === 'Calidad' || User.rol === 'Taller' ) ? <UserInbox />
                  : User && ( User.rol === 'Administrador'  || User.rol === 'SuperUsuario') ? <DashboardN />
                  : <DashboardN />
                  )} />
                <Route path="/dashboard" element={(<DashboardN />)}  />
              
                <Route path="/reporte" element={(<ReporteDocumentos />)}  />
                
                <Route path="/bnovus link" element={<CentroCosto />} />


                {/* pages  */}
                <Route path="/clientes" element={<Clientes />} />
                <Route path="/proyectos" element={<CentroCosto />} />
                <Route path="/equipos" element={<Equipos />} />
                <Route path="/maquinas" element={<Maquinas />} />
                <Route path="/capacidades" element={<Capacidades />} />
                <Route path="/logística de maquinas" element={<AsignaMaquina />} />
                <Route path="/Autorizaciones" element={<Autorizar />} />
                <Route path="/consulta maquinas" element={<ConsultaMaquinas />} />
                <Route path="/implementación" element={<EquipmentReviewInboxFull />} />
                <Route path="/carpetas" element={<Carpetas />} />
                <Route path="/acreditación" element={<Acreditacion />} />
                <Route path="/tickets" element={<Tickets tipo='ALL' estado='ALL' />} />
                <Route path="/cargos" element={<Cargos />} />
                <Route path="/personas" element={<Personas />} />

                <Route path="/salida de obra" element={<SalidaObra />} />
                <Route path="/documentos generales" element={<DocumentosGenerales />} />
                <Route path="/documentos mandantes" element={<AsignaManDocMaq />} />
                <Route path="/gestión de carpetas" element={<GestionCarpetas />} />
                <Route path="/fichas equipos" element={<FichaEquipo />} />
                <Route path="/traspaso de equipo" element={<TraspasoCC />} />
               
                {/* apps  */}
                <Route path="/usuarios" element={<Usuarios />} />
                <Route path="/proveedores" element={<Clientes />} />
                <Route path="/mandantes" element={<Mandantes />} />
                <Route path="/parametros" element={<Parametros />} />

                <Route path="/solicitudes" element={<Solicitudes />} />
                <Route path="/bitacora solicitud" element={<BitacoraSolicitud />} />
                <Route path="/bitacora equipo" element={<BitacoraEquipo />} />
                <Route path="/auditoria" element={<AuditoriaLog />} />
                <Route path="/estatus equipos" element={<EstatusEquipos />} />
                
                <Route path="/notificaciones" element={<UserInbox />} />
  
              </Routes>
            </div>
            <Footer />
          </div>
        </div>
            
    
      </div>
    );

}

export default Home;